import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit/modal';
import { PhonePopupContent } from '../PhonePopup/dump/PhonePopupContent';
import { getSinglePhoneData } from '../../utils/getSinglePhoneData';
import { handleDynamicCalltracking } from '../../utils/handleDynamicCalltracking';
import { jsx as _jsx } from "react/jsx-runtime";
export var PhonePopupModal = function PhonePopupModal(_ref) {
  var open = _ref.open,
    builders = _ref.builders,
    sellers = _ref.sellers,
    httpApi = _ref.httpApi,
    logger = _ref.logger,
    placeType = _ref.placeType,
    pageType = _ref.pageType,
    platformType = _ref.platformType,
    onClose = _ref.onClose,
    onPhoneOpen = _ref.onPhoneOpen;
  var _getSinglePhoneData = getSinglePhoneData({
      builders: builders,
      sellers: sellers
    }),
    siteBlockId = _getSinglePhoneData.siteBlockId,
    name = _getSinglePhoneData.name,
    phone = _getSinglePhoneData.phone,
    logoUrl = _getSinglePhoneData.logoUrl,
    workTime = _getSinglePhoneData.workTime,
    type = _getSinglePhoneData.type,
    title = _getSinglePhoneData.title,
    realtyUserId = _getSinglePhoneData.realtyUserId;
  var _React$useState = React.useState(phone),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    dynamicPhone = _React$useState2[0],
    setPhone = _React$useState2[1];
  var handleDynamicPhone = React.useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$handleDynamicC, _phone;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!siteBlockId) {
            _context.next = 6;
            break;
          }
          _context.next = 3;
          return handleDynamicCalltracking({
            blockId: siteBlockId,
            platformType: platformType,
            pageType: pageType,
            placeType: placeType,
            httpApi: httpApi,
            logger: logger
          });
        case 3:
          _yield$handleDynamicC = _context.sent;
          _phone = _yield$handleDynamicC.phone;
          if (_phone) {
            setPhone(_phone);
          }
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [siteBlockId, realtyUserId, onPhoneOpen]);
  React.useEffect(function () {
    if (open) {
      handleDynamicPhone();
    }
    if (onPhoneOpen) {
      onPhoneOpen({
        realtyUserId: realtyUserId
      });
    }
  }, [handleDynamicPhone, open]);
  return /*#__PURE__*/_jsx(ModalWindow, {
    size: "XS",
    open: open,
    content: /*#__PURE__*/_jsx(PhonePopupContent, {
      name: name,
      phone: dynamicPhone,
      logoUrl: logoUrl,
      workTime: workTime,
      type: type,
      title: title
    }),
    onClose: onClose,
    width: "400px"
  });
};